import { Alert } from '@commenda/kakashi';

const IndirectTaxFilingCalendarNotice = () => (
  <Alert
    variant="info"
    title="Calendar tracking only"
    description="Track filing dates and status here. Tax calculations, approvals, and filing submission are not available for this region."
  />
);

export default IndirectTaxFilingCalendarNotice;
